import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWebAwesome } from '@fortawesome/free-brands-svg-icons';
import { faBomb, faFlag } from '@fortawesome/free-solid-svg-icons';

// Posições da água no tabuleiro
export const posAgua = ['E2', 'E3', 'E6', 'E7', 'F2', 'F3', 'F6', 'F7'];